"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPublished = isPublished;
function isPublished(calculator, now) {
    if (!calculator?.publishedAt)
        return false;
    return new Date(calculator.publishedAt) <= now;
}
